"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@/state/globalStore";
import { type DeleteTargetsRequest } from "@/generated/fastapi";
import { deleteTargets } from "../api/deleteTargets";
import { targetsKeys } from "../queries/keys";

export default function useDeleteTargetsMutation() {
  const queryClient = useQueryClient();
  const { accessToken } = useAuth();

  return useMutation({
    mutationFn: (request: DeleteTargetsRequest) =>
      deleteTargets(accessToken, request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: targetsKeys.all });
    },
  });
}
